<template>
    <v-form ref="form" v-model="valid" class="pb-5">
        <v-container class="payment-container">
            <span class="d-block mb-6">Método de Pagamento:</span>
            <v-row>
                <v-col cols="12" md="4">
                    <v-radio-group
                        v-model="paymentType"
                        label="Pagamento Aceito:"
                        class="ma-0 pa-0"
                        :rules="paymentTypeRules"
                    >
                        <v-radio
                            label="Cartão Virtual"
                            value="virtualCard">
                        </v-radio>
                        <v-radio
                            label="Faturamento"
                            value="invoicing">
                        </v-radio>
                        <v-radio
                            label="Pix"
                            value="pix">
                        </v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" md="4">
                    <v-radio-group
                        :disabled="paymentType !== 'pix'"
                        class="ma-0 pa-0"
                        v-model="pixKeyType"
                        label="Tipo da Chave Pix:"
                    >
                        <v-radio label="CNPJ" value="cnpj"></v-radio>
                        <v-radio label="CPF" value="cpf"></v-radio>
                        <v-radio label="Celular" value="cellphone"></v-radio>
                        <v-radio label="E-mail" value="email"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" md="4" align-self="center">
                    <v-text-field
                        v-model="pixKey"
                        :disabled="paymentType !== 'pix'"
                        :rules="pixKeyRules"
                        v-mask="`${pixKeyMask}`"
                        label="Chave Pix"
                        outlined
                    />
                </v-col>
            </v-row>
        </v-container>
        <v-container v-if="!ownerCreationForm" class="payment-container mt-6">
            <span class="d-block mb-6">Data Preferencial de Pagamento:</span>
            <v-row>
                <v-col cols="12" md="4">
                        <legend class="v-label theme--light">Check-in:</legend>
                        <v-checkbox
                            v-model="paymentDatePreferenceSelected"
                            class="mt-0"
                            label="Antes do Checkin"
                            value="before_checkin"
                            hide-details
                        />
                        <v-checkbox
                            v-model="paymentDatePreferenceSelected"
                            label="Depois do Checkin"
                            class="mt-0"
                            value="after_checkin"
                            hide-details
                        />
                        <legend class="v-label theme--light d-block mt-4">Check-out:</legend>
                        <v-checkbox
                            v-model="paymentDatePreferenceSelected"
                            class="mt-0"
                            label="Antes do Checkout"
                            value="before_checkout"
                            hide-details
                        />
                        <v-checkbox
                            v-model="paymentDatePreferenceSelected"
                            class="mt-0"
                            label="Depois do Checkout"
                            value="after_checkout"
                            hide-details
                        />
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        v-model="paymentDatePreferenceInputDays"
                        outlined
                        :rules="paymentDatePreferenceRules"
                        :disabled="!paymentDatePreferenceSelected"
                        label="Dias"
                        class="mt-4"
                        v-mask="'##'"
                    />
                </v-col>
            </v-row>
        </v-container>
        <v-row class="pa-8">
            <v-col cols="12" md="6" offset-md="3">
                <v-btn
                    depressed
                    color="success"
                    @click="validate"
                    class="w-100"
                >
                    Proximo
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import {isValidCnpj} from "../../../helpers/ValidationRuleHelper";

export default {
    name: "Payment",
    props: {
        hotel: {
            type: Object,
            default: () => {}
        },
        cnpj: {
            type: String,
            default: ''
        },
    },
    inject: ['ownerCreationForm'],
    data: () => ({
        paymentType: 'virtualCard',
        pixKeyType: null,
        pixKey: '',
        paymentDatePreferenceSelected: null,
        paymentDatePreferenceInputDays: '',
        valid: false,
        paymentTypeRules: [
            v => !!v || 'É obrigatório selecionar um tipo de cobrança',
        ],
    }),
    created() {
        if (this.hotel !== null) {
            this.setData();
        }
    },
    computed: {
        pixKeyRules() {
            if (this.paymentType === 'pix') {
                if (this.pixKeyType === 'cpf') {
                    return [
                        v => !!v || 'A chave pix é obrigatória',
                        v => !!v.match('^[0-9]{3}\.[0-9]{3}\.[0-9]{3}\-[0-9]{2}$') || 'Informe um CPF válido'
                    ];
                }
                if (this.pixKeyType === 'cnpj') {
                    return [
                        v => !!v || 'A chave pix é obrigatória',
                        v => isValidCnpj(v) || 'Cnpj inválido',
                    ];
                }
                if (this.pixKeyType === 'email') {
                    return [
                        v => !!v || 'A chave pix é obrigatória',
                        v => !!v.match('^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$') || 'Informe um e-mail válido'
                    ];
                }
                if (this.pixKeyType === 'cellphone') {
                    return [
                        v => !!v || 'A chave pix é obrigatória',
                        v => !v || !!v.match('^\\([0-9]{2}\\)\\ [0-9]{5}\\-[0-9]{4}$') || `Informe um celular valido`
                    ];
                }
            }
            return [];
        },
        paymentDatePreferenceRules() {
            if (this.paymentDatePreferenceSelected !== null) {
                return [
                    v => !!v || 'A quantidade de dias de cobrança é obrigatória',
                    v => v <= 30 && v >= 1 || 'A quantidade de dias de cobrança pode ser no máximo 30 e no mínimo 1',
                ];
            }
            return [];
        },
        pixKeyMask() {
            if (this.pixKeyType === 'cnpj') {
                return 'NN.NNN.NNN/NNNN-##';
            }
            if (this.pixKeyType === 'cpf') {
                return '###.###.###-##';
            }
            if (this.pixKeyType === 'cellphone') {
                return '(##) #####-####';
            }
            return '';
        }
    },
    watch: {
        paymentType(val) {
            if (val === 'pix' && this.pixKeyType === null) {
                this.pixKeyType = 'cnpj';
                this.pixKey = this.hotel?.cnpj ?? this.cnpj;
            }
            if (val !== 'pix') {
                this.pixKeyType = null;
                this.pixKey = null;
            }
        },
        pixKey(val) {
            if (this.pixKeyType === 'cnpj' && val && val !== val.toUpperCase()) {
                this.pixKey = val.toUpperCase();
            }
        },
        paymentDatePreferenceSelected(val) {
            if (val === null) {
                this.paymentDatePreferenceInputDays = '';
            }
        }
    },
    methods: {
        validate() {
            this.$refs.form.validate();
            if (this.valid) {
                this.$emit('goToTab', 'facilities');
            }
        },
        async getData() {
            return {
                "payment_type": this.paymentType,
                "pix_key": this.pixKey,
                "pix_key_type": this.pixKeyType,
                "payment_date_preference_selected": this.paymentDatePreferenceSelected,
                "payment_date_preference_input_days": this.paymentDatePreferenceInputDays
            };
        },
        setData() {
            this.paymentType = this.hotel.payment_type;
            this.pixKey = this.hotel.pix_key;
            this.pixKeyType = this.hotel.pix_key_type;
            this.paymentDatePreferenceSelected = this.hotel.payment_date_preference_selected;
            this.paymentDatePreferenceInputDays = this.hotel.payment_date_preference_input_days;
        },
    },
}
</script>

<style scoped>
.payment-container {
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .38);
    padding: 20px;
}
</style>
